// extracted by mini-css-extract-plugin
module.exports = {"info":"InfoDialog_info__c5flq"};